import register from '../../../../global/js/registry';
export default register('m-professional-anchor-navigation', () => import(/* webpackMode: "lazy" */ './m-professional-anchor-navigation.controller'));
